// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";

// Base Module
import ModuleBase from "#/common/ModuleBase";

// Components
import { Observer } from "mobx-vue";
import * as moment from "moment";

@Observer
@Component({
  mixins: [template],
  components: {},
})
export class SeoMesseModule extends ModuleBase {
  public getBackgroundColorFromInstance(instance: object) {
    return "black";
  }

  get url() {
    return window.location.href;
  }

  formatDate(date: string) {
    let d = moment(date, "DD.MM.YYYY");
    return d.format("YYYY-MM-DD");
  }

  formatDuration(startDate: string, endDate: string) {
    if (startDate && endDate) {
      let parsedStart = moment(startDate, "DD.MM.YYYY");
      let parsedEnd = moment(endDate, "DD.MM.YYYY");

      if (parsedStart && parsedEnd) {
        let duration = moment.duration(parsedEnd.diff(parsedStart)).add(1, "d");
        return duration.toJSON();
      }
    }
  }
}
